import each from 'lodash/each';
import moment from 'moment';

export const buildFormData = (data) => {
  const form = new FormData();
  each(data, (v, k) => form.append(k, v));
  return form;
};

export const normalizeUTCDate = (date) => {
  const utcDate = moment.utc(date);
  return moment().set({
    year: utcDate.year(),
    month: utcDate.month(),
    date: utcDate.date(),
  }).toDate();
};

export const api = path => `${process.env.REACT_APP_API}${path}`;

export const apiErrorToStr = (e) => {
  if (e && e.response) {
    return e.response.status >= 500
      ? `${e.response.statusText}. Please contact your system administrator.`
      : e.response.data.message;
  }

  if (e && e.message) {
    return e.message;
  }

  return 'An unrecognized error has occurred. Please try again later or contact your system administrator.';
};

export const buildCategoryPath = (name, cat, categories, level) => {

  let ret = name;

  if (level > 10) return ret;

  if (cat.parent) {
    categories.forEach((c) => {
      if (c.id === cat.parent) {
        ret = buildCategoryPath(c.name + ' :: ' + ret, c, categories, ++level);
      }
    });
  }

  return ret;
};

export const getCategoryChildrenLevel = (cat, categories, level) => {

  let ret = level;

  categories.forEach((c) => {
    if (c.parent === cat.id) {
      let newret = getCategoryChildrenLevel(c, categories, level + 1);
      if (newret > ret) {
        ret = newret;
      }
    }
  });

  return ret;
};




// WEBPACK FOOTER //
// ./src/utils/index.js